<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        />

        <v-card max-width="650" width="650" v-if="!loading">
          <v-card-title>
            <span class="headline">{{
              $t("users.brandsAddEdit.newBrand")
            }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-text-field
                    v-model="editedItem.name"
                    :label="$t('users.brandsAddEdit.brandName')"
                    color="primary"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="close">{{
              $t("users.brandsAddEdit.cancel")
            }}</v-btn>
            <v-btn color="primary" text @click="save">{{
              $t("users.brandsAddEdit.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import snackbar from "@/utils/snackbar.js";

export default {
  data: () => ({
    loading: true,
    isEditView: false,
    editedItem: {
      name: "",
    },
  }),

  computed: {},

  created() {
    this.loading = false;
  },

  methods: {
    close() {
      this.$router.push({
        name: "brands",
      });
    },

    save() {
      api.createGroup(this.$route.params.id, this.editedItem).then((resp) => {
        this.$router.push({
          name: "brands",
        });
      });
    },
  },
};
</script>
